import React from 'react';
import { Search, X } from 'lucide-react';
import CategoryIconBar from './CategoryIconBar';

const GREEN = '#78BE20';

interface BrowseHeroProps {
  searchText: string;
  onSearch: (text: string, immediate?: boolean) => void;
  activeTypes: string[];
  total: number | null;
}

/**
 * Compact page header: title, live count and search on one row, with the
 * category icon bar beneath. Deliberately plain, the browsing is the point.
 */
const BrowseHero: React.FC<BrowseHeroProps> = ({ searchText, onSearch, activeTypes, total }) => (
  <header className="bg-black text-white">
    <div className="max-w-[1500px] mx-auto px-4 md:px-6 py-2 md:py-5 flex flex-col md:flex-row md:items-center gap-2 md:gap-6">
      <div className="flex items-baseline gap-3 shrink-0">
        <h1 className="font-montserrat font-extrabold tracking-[-0.02em] text-[22px] md:text-[26px] leading-none">
          Clothing
        </h1>
        <span className="font-poppins text-[12px] md:text-[13px] text-white/55 tabular-nums">
          {total !== null ? `${total.toLocaleString('en-GB')} styles` : ' '}
        </span>
      </div>

      <form
        className="md:ml-auto w-full md:max-w-[460px]"
        onSubmit={(e) => {
          e.preventDefault();
          onSearch(searchText, true);
        }}
        role="search"
      >
        <label htmlFor="clothing-search" className="sr-only">
          Search garments
        </label>
        <div className="flex items-center h-10 md:h-11 rounded-full bg-white/10 border border-white/15 pl-4 pr-1.5 focus-within:border-[#78BE20] focus-within:bg-white/[0.14] transition-colors">
          <Search className="w-4 h-4 text-white/50 shrink-0" />
          <input
            id="clothing-search"
            type="search"
            value={searchText}
            onChange={(e) => onSearch(e.target.value)}
            placeholder="Search name, brand or style code"
            className="flex-1 min-w-0 bg-transparent px-3 text-white font-poppins text-[14px] placeholder:text-white/40 outline-none [&::-webkit-search-cancel-button]:hidden"
            autoComplete="off"
          />
          {searchText && (
            <button
              type="button"
              onClick={() => onSearch('', true)}
              className="p-1.5 rounded-full text-white/50 hover:text-white hover:bg-white/10"
              aria-label="Clear search"
            >
              <X className="w-4 h-4" />
            </button>
          )}
          <button
            type="submit"
            className="h-8 px-4 rounded-full font-poppins font-semibold text-[11px] tracking-[0.1em] uppercase text-white transition-colors hover:brightness-110"
            style={{ backgroundColor: GREEN }}
          >
            Search
          </button>
        </div>
      </form>
    </div>

    <CategoryIconBar activeTypes={activeTypes} />
  </header>
);

export default BrowseHero;
